import React, { createContext, useState, useEffect } from "react";
import axiosInstance from "./services/BaseUrl";
// Create the global context
export const GlobalContext = createContext();

// Create a provider component
export const GlobalProvider = ({ children }) => {
 
  const [globalVar, setGlobalVar] = useState('https://www.justoffplan.ai'); 
  // const [globalVar, setGlobalVar] = useState('http://localhost:8000');
  // const [globalVar, setGlobalVar] = useState('http://18.234.135.172'); 

  const [getProperty, setGetProperty] = useState([]);
  const [activeFilters, setActiveFilters] = useState({});
  const [activeFilter, setActiveFilter] = useState(false);
  //Searching
  const [type, setType] = useState(null);
  const [budget, setBudget] = useState("");
  const [handover, setHandover] = useState("");
  const [locationSelect, setLocationSelect] = useState(null);
  const [developer, setDeveloper] = useState(null);
  const [developerOther, setDeveloperOther] = useState("");
  const [project, setProject] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  const [propertyCategory, setPropertyCategory] = useState('all');
  const [selectedLocation, setSelectedLocation] = useState('All Emirates');
  const [leads, setLeads] = useState([]);
  //page
  const [page, setPage] = useState(1);

  // Fetch leads once on mount to populate initial leads list
  const refreshLeads = async () => {
    try {
      const res = await axiosInstance.get("/leads/");
      if (res.data.success) {
        setLeads(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  };

  // Add a new lead at the top of leads array
  const addLead = (newLead) => {
    setLeads(prev => [newLead, ...prev]);
  };

  useEffect(() => {
    refreshLeads();
  }, []);

//   useEffect(() => {
//   const interval = setInterval(() => {
//     refreshLeads();
//   }, 15000); // 15,000 ms = 15 seconds

//   return () => clearInterval(interval); // cleanup on unmount
// }, []);

  return (
    <GlobalContext.Provider value={{
      globalVar,
      setGlobalVar,
      getProperty,
      setGetProperty,

      activeFilters,
      setActiveFilters,

      activeFilter,
      setActiveFilter,

      //Searching
      type,
      setType,
      budget,
      setBudget,
      handover,
      setHandover,
      locationSelect,
      setLocationSelect,
      developer,
      setDeveloper,
      developerOther,
      setDeveloperOther,
      project,
      setProject,
      keywords,
      setKeywords,

      selectedCategory,
      setSelectedCategory,
      propertyCategory,
      setPropertyCategory,
      selectedLocation,
      setSelectedLocation,

      //page
      page,
      setPage,
      // NEW leads state and updater
        leads,
        setLeads,
        addLead,
        refreshLeads,
      }}>
      {children}
    </GlobalContext.Provider>
  );
};